<template>
  <a-badge
    :count="unReadNum"
    :overflow-count="999"
    @click="toNotice"
    style="margin-right: 15px"
  >
    <BellOutlined />
  </a-badge>
</template>

<script>
import { defineComponent, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { BellOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  components: { BellOutlined },
  setup() {
    const router = useRouter();
    const store = useStore();
    const toNotice = () => {
      router.push("/notice");
    };
    const unReadNum = computed(() => store.state.unReadNum);
    return {
      toNotice,
      unReadNum,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
